import { GetterTree } from 'vuex';
import { State } from '@/stores/approvals/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public allApprovals = (state: State) => state.allApprovals;
    public allApprovalsPage = (state: State) => state.allApprovalsPageNumber;
    public allApprovalsPageSize = (state: State) => state.allApprovalsPageSize;
    public allApprovalsTotalPages = (state: State) => state.allApprovalsTotalPages;
    public allApprovalsTotal = (state: State) => state.allApprovalsTotal;
    public allApprovalsFilterStatus = (state: State) => state.allApprovalsFilterStatus;
    public allApprovalsFrom = (state: State) => state.allApprovalsFrom;
    public allApprovalsTo = (state: State) => state.allApprovalsTo;
}
